const gradientColor = {
  'gradient-dark-blue': '#0E3C89',
  'gradient-light-blue': '#3798E4',
};
module.exports = {
  gradientColor,
};
